import React from 'react';
import { Search } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getProjectState } from '../../features/project/selectors';

export default function SearchButton() {
  const history = useHistory();
  const project = useSelector(getProjectState);

  const handleNavigateToSearch = () => {
    history.push(`/main/search${project ? `?projectId=${project.id}` : ''}`);
  };

  return (
    <IconButton onClick={handleNavigateToSearch} style={{ padding: 4, marginRight: 4 }}>
      <Search style={{ color: '#7A797A' }} />
      <span style={{ position: 'absolute', fontSize: '12px', top: 25 }}>FINDER</span>
    </IconButton>
  );
}
